import { useMutation } from "@apollo/client";
import { DELETE_PROGRAM, PROGRAMS } from "../../apollo/queries";
import styles from "./DeleteProgram.module.scss";
import { RemoveProgram } from "../../apollo/types/deleteProgram";

type DeleteProgramProps = {
  onToggle: Function;
  name?: string;
  id: number;
};

export const DeleteProgram = ({ onToggle, name, id }: DeleteProgramProps) => {

  const [deleteProgram] = useMutation<RemoveProgram>(DELETE_PROGRAM, {
    onCompleted: (data) => {
      if (data) {
        onToggle();
      }
    },
    refetchQueries: [{ query: PROGRAMS }],
  });

  const handleDeleteProgram = (id: number) => {
    deleteProgram({ variables: { deleteProgramId: id } });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.subtitle}>
          Programma’s <span> - Verwijdering</span>
        </p>
        <button className={styles.close} onClick={() => onToggle()}>
          X
        </button>
      </div>
      <h2 className={styles.title}>Let op</h2>
      <p className={styles.text}>
        Je staat op het punt om Programma: <span>{name}</span>, Editie 18 te
        verwijderen. Bevestig je keuze hieronder.
      </p>
      <div className={styles.buttons}>
        <button
          className={styles.delete}
          onClick={() => handleDeleteProgram(id)}
        >
          Verwijderen
        </button>
        <button className={styles.cancel} onClick={() => onToggle()}>
          Annuleren
        </button>
      </div>
    </div>
  );
};
